export default __webpack_public_path__ + "static/media/KOL.f8a649ba.png";